import axios from "@/plugins/axios";

let url = (data = {}) => "/api/v1/users/${_user}/files".interpolate(data);

export default {
    post({ _user, type, password }, file) {
        var formData = new FormData();
        if (type) formData.append("type", type);
        if (password) formData.append("password", password);
        formData.append("file", file);

        var headers = { "Content-Type": "multipart/form-data" };
        return axios.post(`${url({ _user })}`, formData, { headers }).then((result) => result.data);
    },
};
